import React from "react";
import { connect } from "react-redux";
import { formatNumberForceSigned } from "../../../lib/commonFunctions";
import LimitLine from "../../GameHeader/Stats/LimitLine";

const DucatsBalance = ({
  ducatsBalance
}) => (
  <>
    <h3 className="title">Ducats balance</h3>
    Traders: <span
    className={ducatsBalance.production > 0 ? "positive" : undefined}>{formatNumberForceSigned(ducatsBalance.production)}</span><br/>
    <br/>
    <LimitLine
      amount={ducatsBalance.limit.amount}
      limit={ducatsBalance.limit.limit}
      market={ducatsBalance.limit.market}
    />
  </>
);

const mapStateToProps = state => ({
  ducatsBalance: state.governorate.resourceBalances.ducats
});

export default connect(mapStateToProps)(DucatsBalance);
